import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const PhoneNumber = ({
  id,
  divClass,
  divStyle,
  txtBoxClass,
  onChange = () => {},
  value = "",
  error = false,
  label,
  name,
  required,
}) => {
  const [activeBorder, setActiveBorder] = useState(false);
  //const txtValue = useRef("")

  const handleFocus = (e) => {
    setActiveBorder(true);
  };

  const handleBlur = (e) => {
    setActiveBorder(false);
  };

  return (
    <div
      className={`field-container light-border ${
        error ? "error" : ""
      } ${divClass} ${activeBorder && "active"}`}
      style={{ divStyle }}
    >
      <label className='always-active' htmlFor={id}>
        {label}
      </label>
      <PhoneInput
        country={"ae"}
        value={value}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        inputClass={txtBoxClass}
        // inputStyle={{ border: "none", width: "100%" }}
        dropdownStyle={{ border: "none", textAlign: "left" }}
        name={name}
        enableSearch
        autoFormat
        // inputStyle={{ width: "21.4em!important" }}
        required
      />
    </div>
  );
};

export default PhoneNumber;
